"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.R = void 0;
const Leaf = __importStar(require("leaf-ts"));
var R;
(function (R) {
    var _a;
    let WidgetCompileInfo;
    if (typeof NO_COMPILE_INFO === "undefined" || !NO_COMPILE_INFO) {
        WidgetCompileInfo = {
            "project": "/dev/shm/VersetProduction/verset-webapp.release/prod-497674fb-c4e34b12612d",
            "path": "src/script/subscriptionHint/subscriptionHint.theme/genesis/subscriptionHint.html",
            "namespace": "R",
            "created": "2026-11-01 23:50:06"
        };
    }
    class SubscriptionHint extends Leaf.GeneratedWidget {
        static { _a = Leaf.CompileInfoSymbol; }
        constructor() {
            super(Leaf.WidgetThemeCenter.getThemeGenerator(SubscriptionHint), "SubscriptionHint", []);
            this.TestDatas = SubscriptionHint.TestDatas;
            this.BindedLists = SubscriptionHint.BindedLists;
            this.BindedWidgets = SubscriptionHint.BindedWidgets;
            this.InitialData = SubscriptionHint.InitialData;
            this.path = SubscriptionHint.path;
            this.GeneratedConstructor = SubscriptionHint;
            if (SubscriptionHint.InitialData) {
                this.renderRecursive(SubscriptionHint.InitialData);
            }
        }
        static { this[_a] = WidgetCompileInfo && {
            ...WidgetCompileInfo,
            namespace: "R.SubscriptionHint",
        }; }
        static { this.generator = function () {
            var _e = this._e.bind(this);
            var _t = this._t.bind(this);
            return _e("div", { "data-theme": { "name": "data-theme", "templates": [{ "type": "raw", "content": "genesis" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "subscription-hint-7fe8e0" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "eyebrow" }] } }, [_t({ "templates": [{ "type": "raw", "content": "AI usage" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "message" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Unlock the full potential of Verset." }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "actions" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n        " }] }), _e("button", { "type": { "name": "type", "templates": [{ "type": "raw", "content": "button" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "primary" }] }, "data-id": { "name": "data-id", "templates": [{ "type": "raw", "content": "openSubscription" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Subscribe" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n        " }] }), _e("button", { "type": { "name": "type", "templates": [{ "type": "raw", "content": "button" }] }, "data-id": { "name": "data-id", "templates": [{ "type": "raw", "content": "later" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Later" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] })]), _t({ "templates": [{ "type": "raw", "content": "\n" }] })]);
        }; }
        static { this.TestDatas = []; }
        static { this.BindedLists = []; }
        static { this.BindedWidgets = []; }
        static { this.path = "/script/subscriptionHint/subscriptionHint.theme/genesis/subscriptionHint"; }
        static { this.widgetName = "SubscriptionHint"; }
        static { this.InitialData = null; }
    }
    R.SubscriptionHint = SubscriptionHint;
    SubscriptionHint["prototype"].widgetName = "SubscriptionHint";
})(R || (exports.R = R = {}));
if (typeof NO_LESS_IN_SOURCE === "undefined" || !NO_LESS_IN_SOURCE) {
    const lessContent = "\n.subscription-hint-7fe8e0 {\n\n    & { display: flex; flex-direction: column; gap: 4px; min-width: 0; }\n    .eyebrow { color: rgba(255, 255, 255, .5); font-size: 10px; font-weight: 700; letter-spacing: .1em; line-height: 1.3; text-transform: uppercase; }\n    .message { color: rgba(255, 255, 255, .82); font-size: 12px; font-weight: 400; line-height: 1.5; }\n    .actions { display: flex; flex-wrap: wrap; align-items: center; gap: 4px; margin-top: 4px; }\n    button { display: inline-flex; align-items: center; justify-content: center; box-sizing: border-box; height: 26px; padding: 0 7px; border: 1px solid transparent; border-radius: 3px; background: transparent; color: rgba(255, 255, 255, .58); font: inherit; font-size: 12px; font-weight: 400; line-height: 1; cursor: pointer; }\n    button:hover { background: #303336; color: #e2e3e1; }\n    .primary { background: #d5d8dc; border-color: #d5d8dc; color: #181a1b; font-weight: 600; }\n    .primary:hover { background: #eceef0; border-color: #eceef0; color: #181a1b; }\n    button:focus-visible { outline: 2px solid #b0b6be; outline-offset: 2px; }\n\n\n}\n\n";
    const _global = globalThis;
    _global.lesses = _global.lesses || [];
    _global.lesses.push({ filename: __filename, less: lessContent });
}
